import React, { useState, useCallback, useMemo, useRef } from 'react';
import DataTable from 'react-data-table-component';
import Notification from 'components/Notification';
import { useLocation, useNavigate } from 'react-router';
import { ANDROID_LOWERCASE, PAGINATION, WEB_LOWERCASE } from 'utils/constants';
import { useQuery } from 'react-query';
import segmentTargetService from 'utils/network/segment-target/segment-target.service';

function useQueryParam() {
  return new URLSearchParams(useLocation().search);
}

export default function SegmentTarget() {
  const navigate = useNavigate();
  const queryParam = useQueryParam();
  const columns = [
    {
      name: 'Customer ID',
      sortable: true,
      selector: 'customer_id',
      cell: function render(row) {
        return <>{row.customer_id}</>;
      }
    },
    {
      name: 'Name',
      sortable: true,
      selector: 'name',
      cell: function render(row) {
        return <>{row.name}</>;
      }
    },
    {
      name: 'Email',
      sortable: true,
      selector: 'email',
      cell: function render(row) {
        return <>{row.email}</>;
      }
    },
    {
      name: 'Device Type',
      cell: function render(row) {
        return (
          <>
            {row.device_type === ANDROID_LOWERCASE ? (
              <svg
                key={row.id}
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 mr-3"
                x="0"
                y="0"
                fill="#3CDB85"
                enableBackground="new 0 0 553.048 553.048"
                version="1.1"
                viewBox="0 0 553.048 553.048"
                xmlSpace="preserve"
              >
                <path d="M76.774 179.141c-9.529 0-17.614 3.323-24.26 9.969-6.646 6.646-9.97 14.621-9.97 23.929v142.914c0 9.541 3.323 17.619 9.97 24.266 6.646 6.646 14.731 9.97 24.26 9.97 9.522 0 17.558-3.323 24.101-9.97 6.53-6.646 9.804-14.725 9.804-24.266V213.039c0-9.309-3.323-17.283-9.97-23.929-6.647-6.646-14.627-9.969-23.935-9.969zM351.972 50.847L375.57 7.315c1.549-2.882.998-5.092-1.658-6.646-2.883-1.34-5.098-.661-6.646 1.989l-23.928 43.88c-21.055-9.309-43.324-13.972-66.807-13.972-23.488 0-45.759 4.664-66.806 13.972l-23.929-43.88c-1.555-2.65-3.77-3.323-6.646-1.989-2.662 1.561-3.213 3.764-1.658 6.646l23.599 43.532c-23.929 12.203-42.987 29.198-57.167 51.022-14.18 21.836-21.273 45.698-21.273 71.628h307.426c0-25.924-7.094-49.787-21.273-71.628-14.181-21.824-33.129-38.819-56.832-51.022zm-136.433 63.318c-2.552 2.558-5.6 3.831-9.143 3.831-3.55 0-6.536-1.273-8.972-3.831-2.436-2.546-3.654-5.582-3.654-9.137 0-3.543 1.218-6.585 3.654-9.137 2.436-2.546 5.429-3.819 8.972-3.819s6.591 1.273 9.143 3.819c2.546 2.558 3.825 5.594 3.825 9.137-.007 3.549-1.285 6.591-3.825 9.137zm140.086 0c-2.441 2.558-5.434 3.831-8.971 3.831-3.551 0-6.598-1.273-9.145-3.831-2.551-2.546-3.824-5.582-3.824-9.137 0-3.543 1.273-6.585 3.824-9.137 2.547-2.546 5.594-3.819 9.145-3.819 3.543 0 6.529 1.273 8.971 3.819 2.438 2.558 3.654 5.594 3.654 9.137 0 3.549-1.217 6.591-3.654 9.137zM123.971 406.804c0 10.202 3.543 18.838 10.63 25.925 7.093 7.087 15.729 10.63 25.924 10.63h24.596l.337 75.454c0 9.528 3.323 17.619 9.969 24.266s14.627 9.97 23.929 9.97c9.523 0 17.613-3.323 24.26-9.97s9.97-14.737 9.97-24.266v-75.447h45.864v75.447c0 9.528 3.322 17.619 9.969 24.266s14.73 9.97 24.26 9.97c9.523 0 17.613-3.323 24.26-9.97s9.969-14.737 9.969-24.266v-75.447h24.928c9.969 0 18.494-3.544 25.594-10.631 7.086-7.087 10.631-15.723 10.631-25.924V185.45h-305.09v221.354zM476.275 179.141c-9.309 0-17.283 3.274-23.93 9.804-6.646 6.542-9.969 14.578-9.969 24.094v142.914c0 9.541 3.322 17.619 9.969 24.266s14.627 9.97 23.93 9.97c9.523 0 17.613-3.323 24.26-9.97s9.969-14.725 9.969-24.266V213.039c0-9.517-3.322-17.552-9.969-24.094-6.647-6.53-14.737-9.804-24.26-9.804z"></path>
              </svg>
            ) : row.device_type === WEB_LOWERCASE ? (
              <svg
                key={row.id}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-5 w-5 mr-3"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                />
              </svg>
            ) : (
              <svg
                key={row.id}
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 mr-3"
                x="0"
                y="0"
                enableBackground="new 0 0 512 512"
                version="1.1"
                viewBox="0 0 512 512"
                xmlSpace="preserve"
              >
                <path d="M185.255 512c-76.201-.439-139.233-155.991-139.233-235.21 0-129.404 97.075-157.734 134.487-157.734 16.86 0 34.863 6.621 50.742 12.48 11.104 4.087 22.588 8.306 28.975 8.306 3.823 0 12.832-3.589 20.786-6.738 16.963-6.753 38.071-15.146 62.651-15.146h.146c18.354 0 74.004 4.028 107.461 54.272l7.837 11.777-11.279 8.511c-16.113 12.158-45.513 34.336-45.513 78.267 0 52.031 33.296 72.041 49.292 81.665 7.061 4.248 14.37 8.628 14.37 18.208 0 6.255-49.922 140.566-122.417 140.566-17.739 0-30.278-5.332-41.338-10.034-11.191-4.761-20.845-8.862-36.797-8.862-8.086 0-18.311 3.823-29.136 7.881C221.496 505.73 204.752 512 185.753 512h-.498zM351.343 0c1.888 68.076-46.797 115.304-95.425 112.342C247.905 58.015 304.54 0 351.343 0z"></path>
              </svg>
            )}
          </>
        );
      }
    },
    {
      name: 'FCM Token',
      cell: function render(row) {
        return <>{row.fcm_token}</>;
      }
    }
  ];

  const [pagination, setPagination] = useState({
    page: PAGINATION.DEFAULT_PAGE,
    perPage: PAGINATION.DEFAULT_PER_PAGE,
    search: PAGINATION.DEFAULT_KEYWORD,
    totalPage: PAGINATION.DEFAULT_TOTAL_PAGE,
    totalData: PAGINATION.DEFAULT_TOTAL_DATA
  });
  const [notification, setNotification] = useState({
    show: false,
    error: false,
    title: '',
    message: ''
  });
  const [sortProp, setSortProp] = useState({
    order: 'created_at',
    sort: 'desc'
  });

  const queryKey = useMemo(() => {
    return `segment-target-list--${JSON.stringify({
      page: pagination.page,
      perPage: pagination.perPage,
      search: pagination.search,
      sortProp
    })}`;
  }, [pagination.page, pagination.perPage, pagination.search, sortProp]);

  // get list
  const { data, isLoading: getTargetLoading } = useQuery({
    queryKey,
    queryFn: () => {
      return segmentTargetService.list({
        limit: pagination.perPage,
        keyword: pagination.search,
        offset: pagination.page,
        order: sortProp.order,
        sort: sortProp.sort,
        segment_id: parseInt(queryParam.get('id'))
      });
    }
  });

  const handlePerRowsChange = useCallback(
    (newPerPage, page) => {
      setPagination({
        ...pagination,
        page,
        perPage: newPerPage,
        totalPage: Math.ceil(data?.data?.total_data / newPerPage)
      });
    },
    [data]
  );

  function handlePageChange(page) {
    setPagination({
      ...pagination,
      page
    });
  }

  function closeNotification() {
    setNotification({ ...notification, show: false });
  }

  const handleSort = useCallback((column, sortDirection) => {
    setSortProp({
      ...sortProp,
      order: column.selector,
      sort: sortDirection
    });
  });

  const searchDebounce = useRef();

  return (
    <div>
      <div className="flex flex-row my-3">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 px-4 py-2 mt-3 text-sm font-medium text-center text-white border border-transparent rounded-lg leading-5 transition-colors duration-150 bg-secondary hover:bg-yellow-700 focus:outline-none focus:shadow-outline-purple"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="#fff"
            viewBox="0 0 256 256"
          >
            <path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path>
          </svg>
          <span>Back</span>
        </button>
      </div>
      <div className="flex flex-row items-center justify-between">
        <h2 className="my-6 text-xl font-semibold text-gray-700 dark:text-gray-200">
          Segment Target - {queryParam.get('name')} - Source:{' '}
          {queryParam.get('source')}
        </h2>
        <button className="px-4 py-2 mt-3 text-sm font-medium text-center text-white bg-purple-600 border border-transparent rounded-lg opacity-0 pointer-events-none leading-5 transition-colors duration-150 active:bg-purple-600 hover:bg-purple-700 focus:outline-none focus:shadow-outline-purple">
          Add New
        </button>
      </div>
      <div className="flex flex-row items-center gap-3 pb-3">
        <div className="relative">
          <input
            className="block w-full px-3 py-2 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
            placeholder="John Doe"
            name="search"
            onChange={({ target: { value } }) => {
              if (searchDebounce.current) {
                clearTimeout(searchDebounce.current);
              }

              searchDebounce.current = setTimeout(() => {
                setPagination({ ...pagination, search: value });
              }, 800);
            }}
          />
          <div className="absolute top-0 bottom-0 flex flex-row items-center h-full right-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={data?.data?.data || []}
        responsive
        sortServer
        onSort={handleSort}
        progressPending={getTargetLoading}
        pagination
        paginationServer
        paginationTotalRows={data?.data?.total_data || 0}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
      />

      <Notification
        notification={notification}
        closeNotification={closeNotification}
      />
    </div>
  );
}
